
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import { BraSquareMeterConfigurationClient } from '@/services/Services';
import InfoModal from '@/components/modals/infoModal.vue';

@Options({})
export default class UploadBraExcelModal extends Vue {

    file: File = null;

    @Prop() callback: any;

    uploadFile() {
        BraSquareMeterConfigurationClient.createComboConfigFromExcel(this.file)
        .then(x => {
            this.callback();
        })
        .catch(y => {
            this.$opModal.show(InfoModal, {
                text:this.$localizationService.getLocalizedValue("Error", "Error"),
                subtitle: y ? y : this.$localizationService.getLocalizedValue("Something went wrong", "Something went wrong"),
                deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                denyCb: () => {
                    this.callback();
                }
            })
        })
    }
    
}
